import React from 'react';
import { NextUI } from '@/components/NextUI';
import FormCard from '../../../../components/Layouts/Default/FormCard';
import Button from '@/components/NextUI/Button';
import { useTranslations } from 'next-intl';

const CompanyModal: React.FC = () => {
  const t = useTranslations('modals.company');

  return (
    <NextUI.Modal
      className="max-w-[500px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8' }}
      defaultOpen={true}
      name={'CompanyModal'}
    >
      <h2 className="h5 font-semibold text-start text-dark">{t('title')}</h2>

      <FormCard
        isAction={false}
        className="mt-8 "
        classNames={{
          actionButton: 'max-w-[160px]',
          actionWrapper: 'mt-8 pb-6 inline-flex flex-col items-end p-0',
          formBody: 'p-0 gap-5',
        }}
      >
        <NextUI.Input
          type="text"
          formNoValidate
          variant="outline"
          radius="sm"
          placeholder={t('fields.company_name')}
        />
        <NextUI.Input
          type="text"
          formNoValidate
          variant="outline"
          radius="sm"
          placeholder={t('fields.billing_address')}
        />
        <NextUI.Input
          type="text"
          formNoValidate
          variant="outline"
          radius="sm"
          placeholder={t('fields.vat_number')}
        />
        <NextUI.Input
          type="email"
          formNoValidate
          variant="outline"
          radius="sm"
          placeholder={t('fields.billing_email')}
        />

        <div className="flex justify-end gap-4">
          <Button variant="outline" className="w-[160px]">
            {t('buttons.cancel')}
          </Button>

          <Button className="w-[160px]">{t('buttons.change')}</Button>
        </div>
      </FormCard>
    </NextUI.Modal>
  );
};

export default CompanyModal;
